
export const noVideoWhiteList = {
    "3987942":["9031868222932750952","default"],
    "4305315":["9031868222940503268","default"],
    "5307153":["4564972818793492951","default"],
    "5377397":["4564972818949157884","default"],
    "5422200":["4564972819144693843","default"],
    "5577984":["7447398154882505125","default"],
    "5806606":["7447398155150617315","default"],
    "5889230":["7447398155271483924","default"],
    "5973757":["7447398155561833074","default"],
    "5981984":["7447398155562116501","default"],
    "5982006":["7447398155562247943","default"],
    "6083496":["7447398155644023775","default"],
    "6123734":["7447398155797248773","default"],
    "5999702":["7447398155818589686","default"],
    "5999758":["7447398156224933310","default"],
    "5999784":["7447398156009451397","default"],
    "5999924":["7447398156086028127","default"],
    "6000006":["7447398156157813835","default"],
    "6000015":["7447398156185001292","default"],
    "6000071":["7447398156281898951","default"],
    "6000083":["7447398156313623578","default"],
    "6000093":["7447398156356023123","default"],
    "6000134":["7447398156444745524","default"],
    "6000139":["7447398156453400145","default"],
    "6000146":["7447398156487145489","default"],
    "6000158":["7447398156605376145","default"],
    "6000169":["7447398156614713051","default"],
    "6000176":["7447398156641817971","default"],
    "7548805":["7447398157053502418","default"],
    "7576132":["7447398157050420830","default"],
    "7588253":["7447398157131095185","default"],
    "7622842":["7447398157050489094","default"],
    "7654753":["5285890780495108926","default"],
    "7688406":["5285890780501023555","default"],
    "7654794":["5285890780512429670","default"],
    "7655237":["5285890780565689688","default"],
    "7655273":["5285890780684102644","default"],
}



// WEBPACK FOOTER //
// ./src/no-video-white-list.js